import React, { useEffect, useState } from 'react';
import {
	Buttonwrapper,
	EmailResp,
	Label,
	Line,
	MailContainer,
	StyledTable,
	SubjectWrapper,
	Textarea,
	Value,
	ValueWrapper,
} from './SendMail.style';
import {
	ApButtonSecondary,
	ApIcon,
	ApInput,
} from '@alixpartners/ui-components';
import MultiSelect from '../MultiSelect';
import { getWorkshopName, sendMailtoSpendOwners } from 'utils/apiRequests';
import { LINK_TYPES } from '../utils';
import Dropzone from 'react-dropzone';

const SendMail = props => {
	const [sendMail, setSendMail] = useState({
		id: '',
		ccEmails: '',
		subject: '',
		file: '',
		message: '',
	});
	const [mailResponse, setMailResponse] = useState('');
	const [attachmentUploaded, setAttachmentuploaded] = useState(false);
	const [workshopGroup, setWorkshopGroup] = useState({
		options: [],
		selectedWorkshopGroup: [],
		spendOwners: [],
		selectedSpendOwner: [],
		spendOwnerForWorkshopGroup: [],
	});

	const [loading, setLoading] = useState(false);
	const { location } = props;

	useEffect(() => {
		setLoading(true);
		let params = {
			type: location.pathname.includes('saving-sign-off') ? 2 : 1,
		};
		getWorkshopName(params).then(response => {
			const optionsResponse = Object.keys(response.data.workshopOwners).map(
				option => ({
					label: option,
					value: option,
				})
			);
			const spendOwnerResponse = response.data.workshopOwners;
			const singleOptionSelection =
				optionsResponse.length === 1 ? [optionsResponse[0].label] : [];

			const selectedSpendOwner =
				optionsResponse.length === 1
					? spendOwnerResponse[optionsResponse[0].label]
					: [];
			setWorkshopGroup(prevState => ({
				...prevState,
				options: optionsResponse,
				selectedWorkshopGroup: singleOptionSelection,
				spendOwners: spendOwnerResponse,
				spendOwnerForWorkshopGroup: selectedSpendOwner.map(option => ({
					label: option,
					value: option,
				})),
				selectedSpendOwner: selectedSpendOwner,
			}));
		});
		setLoading(false);
		// eslint-disable-next-line
	}, []);

	const handleChange = (change, changeContent) => {
		if (change === 'ownerId') {
			setSendMail(prevState => ({
				...prevState,
				id: changeContent,
			}));
		} else if (change === 'ownerMessage') {
			setSendMail(prevState => ({ ...prevState, message: changeContent }));
		} else if (change === 'cc') {
			setSendMail(prevState => ({ ...prevState, ccEmails: changeContent }));
		} else {
			setSendMail(prevState => ({
				...prevState,
				subject: changeContent,
			}));
		}
	};

	const onFilterChangeHandler = value => {
		const spendOwnerOptionsToSet = Array.from(
			new Set(value.map(option => workshopGroup.spendOwners[option]).flat())
		);
		if (spendOwnerOptionsToSet.length === 1 && value.length > 0) {
			setWorkshopGroup(prevState => ({
				...prevState,
				selectedSpendOwner: spendOwnerOptionsToSet,
			}));
		} else {
			setWorkshopGroup(prevState => ({
				...prevState,
				selectedSpendOwner: [],
			}));
		}
		setWorkshopGroup(prevState => ({
			...prevState,
			selectedWorkshopGroup: value,
			spendOwnerForWorkshopGroup: spendOwnerOptionsToSet.map(option => ({
				label: option,
				value: option,
			})),
		}));
	};
	const onSpendOwnerSelectionChanged = value => {
		setWorkshopGroup(prevState => ({
			...prevState,
			selectedSpendOwner: value,
		}));
	};
	const onFileSelected = async acceptedFiles => {
		const payloadFile = acceptedFiles[0];
		setSendMail(prevState => ({ ...prevState, file: payloadFile }));
		setAttachmentuploaded(true);
	};

	const handleEmailSend = (loc, credentials) => {
		const link = loc.pathname.split('/');
		setAttachmentuploaded(false);
		// const payload = {
		// 	type: 0,
		// 	message: credentials.message,
		// 	linkNumber: LINK_TYPES[link[2]].toString(),
		// 	workshopName: workshopGroup.selectedWorkshopGroup,
		// 	subject: credentials.subject,
		// };
		const formData = new FormData();
		formData.append('file', sendMail.file);
		formData.append('type', 0);
		formData.append(
			'location',
			location.pathname.includes('saving-sign-off') ? 2 : 1
		);
		formData.append('linkNumber', LINK_TYPES[link[2]]);
		formData.append('message', credentials.message);
		formData.append(
			'workshopName',
			JSON.stringify(workshopGroup.selectedWorkshopGroup)
		);
		formData.append('subject', credentials.subject);
		formData.append('ccEmails', credentials.ccEmails);
		formData.append(
			'spendOwners',
			JSON.stringify(workshopGroup.selectedSpendOwner)
		);
		sendMailtoSpendOwners(formData).then(response => {
			setSendMail({
				id: '',
				message: '',
				subject: '',
				ccEmails: '',
				file: '',
			});
			setWorkshopGroup(prevState => ({
				...prevState,
				selectedWorkshopGroup: [],
				selectedSpendOwner: [],
			}));
			if (response.succeeded) {
				setMailResponse('Sent successfully');
			} else {
				setMailResponse('Error!');
			}
			setTimeout(
				() => {
					setMailResponse('');
				},
				[4000]
			);
		});
	};

	return (
		<MailContainer>
			<StyledTable>
				<Line>
					<Label>Email</Label>
					<Value>
						<ValueWrapper>
							<MultiSelect
								name="workshop_group"
								label="Workshop Group"
								options={workshopGroup.options}
								selected={workshopGroup.selectedWorkshopGroup}
								isLoading={loading}
								onChange={v => {
									onFilterChangeHandler(v);
								}}
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Spend Owner</Label>
					<Value>
						<ValueWrapper>
							<MultiSelect
								name="spend owners"
								options={workshopGroup.spendOwnerForWorkshopGroup}
								selected={workshopGroup.selectedSpendOwner}
								onChange={v => onSpendOwnerSelectionChanged(v)}
								label="Spend Owners"
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>CC</Label>
					<Value>
						<SubjectWrapper>
							<ApInput
								value={sendMail.ccEmails}
								type="text"
								name={'cc'}
								onChange={event => handleChange('cc', event)}
							/>
						</SubjectWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Subject</Label>
					<Value>
						<SubjectWrapper>
							<ApInput
								value={sendMail.subject}
								type="text"
								name={'ownerSubject'}
								onChange={event => handleChange('ownerSubject', event)}
							/>
						</SubjectWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Message</Label>
					<Value>
						<>
							<Textarea
								rows={5}
								value={sendMail.message}
								onChange={event =>
									handleChange('ownerMessage', event.target.value)
								}
							/>
						</>
					</Value>
				</Line>
			</StyledTable>
			<Buttonwrapper>
				<div style={{ marginLeft: '10px' }}>
					<Dropzone onDrop={onFileSelected} style={{}} noKeyboard>
						{({ getRootProps, getInputProps }) => (
							<div {...getRootProps()}>
								<input {...getInputProps()} />
								<ApButtonSecondary>
									<ApIcon material iconName="attach_file" />Attachment
								</ApButtonSecondary>
							</div>
						)}
					</Dropzone>
				</div>
				<ApButtonSecondary
					onClick={() => handleEmailSend(location, sendMail)}
					disabled={
						workshopGroup.selectedWorkshopGroup.length === 0 ||
						sendMail.message === ''
					}
				>
					Send Email
				</ApButtonSecondary>
				<EmailResp>
					{attachmentUploaded ? <ApIcon material iconName="check" /> : null}
					{mailResponse === '' ? null : mailResponse}
				</EmailResp>
			</Buttonwrapper>
		</MailContainer>
	);
};

export default SendMail;
